// import hooks
import i18n from 'config/i18n';
import * as yup from 'yup';

// import utils
import { getLocale } from 'utils/date';

const t = i18n.getFixedT(getLocale(), 'common');

export const schema = yup.object({
  clientBrDynId: yup
    .number()
    .nullable()
    .typeError(t('surchargeRelations.invalid_client')),
  employerBrDynId: yup
    .number()
    .nullable()
    .typeError(t('surchargeRelations.invalid_employer')),
  surchargeCode: yup
    .number()
    .typeError(t('surchargeRelations.invalid_surcharge'))
});
